export default {"src":"/_next/static/media/dots-horizontal.5a5c8db5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};